import { QElement } from "./QElement";

export class QHoverBox extends QElement {
  constructor() {
    super();
  }

  initRectElement(parentPanel, x, y, width, height, color) {
    this.SizeElement(width, height);
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var ex = this.GetWidth();
    var ey = this.GetHeight();
    ctx.save();
    if (ex == 0 || ey == 0) return;
    ctx.lineWidth = 0.8;
    ctx.fillStyle = "#CAE5FF";
    ctx.strokeStyle = "#45B3F8";
    var elementW = this.GetWidth();
    var elementH = this.GetHeight();

    var panelX = this.GetPositionX();
    var panelY = this.GetPositionY();

    var boxLeft = panelX;
    var boxTop = panelY;
    var boxRight = panelX + elementW;
    var boxBottom = panelY + elementH;

    ctx.beginPath();
    ctx.moveTo(boxLeft, boxTop);
    ctx.lineTo(boxRight, boxTop);
    ctx.lineTo(boxRight, boxBottom);
    ctx.lineTo(boxLeft, boxBottom);
    ctx.lineTo(boxLeft, boxTop);
    ctx.stroke();
    ctx.closePath();

    ctx.globalCompositeOperation = "source-over";
    ctx.globalAlpha = 0.5;
    ctx.fill();
    ctx.restore();
  }
}
